import React from "react";
import { RouteObject } from "react-router-dom";
import { CompanyPage } from "./ui";

export const companyRoute: RouteObject = {
  path: "/about",
  element: <CompanyPage />,
};
